import { Environment } from '@app/shared/models/environment';

export const environment: Environment = {
    appId: 'admin',
    production: true,

    serverUrl: `https://func-online-ordering.azurewebsites.net/api`,

    privateContainerName: 'production-private',
    publicContainerName: 'production-public',

    storageSasUri: 'https://booyahbagels.blob.core.windows.net/',

    buildVersion: '1.0.42',
    buildDate: '2026-03-07T00:42:54+00:00',
    buildCommit: '8361832c861a14eede8b69747f486a18a169693c'
};
